<template>
    <div id="pro-cmaj-form">
        <div class="pt-5 pb-5 header w-100" v-if="!noHeader">
            <h1 class="mx-auto col-11" v-if="code !== null && code !== undefined">Désolé ...</h1>
            <div v-else-if="loaded" class="mx-auto col-11 d-flex justify-content-between">
                <div>
                    <h4 style="color: gray" v-if="formTitle !== null">{{ formTitle }}</h4>
                    <h1 v-if="cadhTitle !== null" class="main-title-form">{{ cadhTitle }}</h1>
                    <h1 v-else>Formulaire d'adhésion</h1>
                </div>
                <div class="logo ml-3">
                    <v-img height="100px"
                           max-width="300px"
                           position="right"
                           v-if="logo !== null"
                           contain :src="logo.doc_url"></v-img>
                </div>
            </div>

            <div v-else class="mx-auto col-11">
                <content-placeholders class="d-flex justify-content-between">
                    <content-placeholders-heading class="place-holder-title-xs" style="width: 400px; height: 51px"/>
                    <content-placeholders-img class="place-holder-title-lg ml-3" style="width: 150px; height: 80px">
                    </content-placeholders-img>
                </content-placeholders>
            </div>
        </div>

        <div class="pro-main-container-bloc pt-5"
             :style="'background-color:' + backGroundColor + '!important'">
            <div class="mx-auto col-11">
                <adhesion :token="token"
                          :base-api-url="baseApiUrl"
                          :payfip-code="payfipCode"
                          :email-test="emailTest"
                          :url-cl="payfipUrlcl"
                          :user="user !== null && user !== undefined">
                </adhesion>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "ProAdhesion",
    data() {
        return {
            code: null,
            loaded: false,
            token: null,
            formTitle: null,
            cadhTitle: null,
            logo: null,
            baseApiUrl: process.env.VUE_APP_API_URL,
            payfipCode: process.env.VUE_APP_PAYFIP_CODE,
            emailTest: process.env.VUE_APP_PAYFIP_EMAIL_TEST,
            payfipUrlcl: process.env.VUE_APP_PAYFIP_URLCL,
            noHeader: false,
            backGroundColor: '#f4f5f7',
        }
    },
    methods: {
        getFormTitles() {
            this.$http.get('adhesion/form-titles/' + this.token).then(res => {
                if(res.body.result === 'success') {
                    this.cadhTitle = res.body.data.cadhTitle
                    this.formTitle = res.body.data.offerTitle
                    this.logo      = res.body.data.logo

                    if(res.body.data.backgroundColor !== null) {
                        this.backGroundColor = res.body.data.backgroundColor
                    }
                } else {
                    this.code = 404
                }

              if (this.user === null || this.user === undefined) {
                this.$http.get('adhesion/opened/' + this.token)
              }

                this.loaded = true
            })
        },
    },
    computed: {
    ...mapState('account', ['user']),
    },
    mounted() {
        document.addEventListener('wheel', this.scroll)
        document.addEventListener('scroll', this.scroll)
    },
    created() {
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
        })

        let pathMatch = this.$route.params.pathMatch
        let paths     = pathMatch.split('/')

        this.token = paths[1]

        this.noHeader = this.$route.query.hidden && this.$route.query.hidden.includes('HEADER')

        this.getFormTitles()
    },
    beforeDestroy() {
        document.removeEventListener('wheel', this.scroll)
        document.removeEventListener('scroll', this.scroll)
    }
}
</script>